import * as React from 'react';

import {reduxForm} from 'redux-form';

import {SidebarFormWrapper} from 'shells/form/sidebar-form-wrapper';

import {FORM_NAME} from './constants';

type Props = {
    title: string;
    subtitle: string;
    onClose: () => void;
    isSaving: boolean;
    isNewItem: boolean;
    children: React.ReactNode;
    deleteProps?: {
        onDelete: () => Promise<any>;
        buttonText?: string;
        title: string;
        message: string;
    };
    saveFailedErrorMessage: string | null | undefined;
    handleSubmit: (eventOrSubmit?: any) => undefined | Promise<any>;
    invalid: boolean;
    pristine: boolean;
    submitting: boolean;
};

function SpamPreventionSidebarFormConnected(props: Props) {
    return <SidebarFormWrapper {...props} />;
}

export const SpamPreventionSidebarForm = reduxForm({
    form: FORM_NAME,
    destroyOnUnmount: true,
    enableReinitialize: true,
    // @ts-expect-error
})(SpamPreventionSidebarFormConnected);
